import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import "./AlertMessageDisplay.css";
import Modal from "./Modal";
import arrowLeftOutlineImage from "../../../images/dashboardLightsLogos/arrow-left-thick.svg";

const Level = {
  Info: "info",
  Warning: "warning",
  Error: "error",
  Success: "success",
};

export default function AlertMessageDisplay({ alerts }) {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState([]);
  const [closeButtonIsClicked, setCloseButtonIsClicked] = useState(false);

  const [currentMessage, setCurrentMessage] = useState(false);
  const [newAlert, setNewAlert] = useState(true);
  const [lastAlert, setLastAlert] = useState("");

  useEffect(() => {
    const errorAlerts = alerts.filter((alert) => alert.level === Level.Error);

    if (closeButtonIsClicked) {
      setShowMessage(false);
      setCloseButtonIsClicked(false);
      setCurrentMessage(true);

      setMessage([]);
    } else if (errorAlerts.length > 0 && !showMessage && !currentMessage) {
      console.log("Opening alert modal");
      const newMessage = errorAlerts[0].message;
      setMessage((preAlert) => [...preAlert, newMessage]);
      setLastAlert(newMessage);
      setShowMessage(true);
    }
    if (errorAlerts.length === 0) {
      setCurrentMessage(false);
    }
  }, [alerts, closeButtonIsClicked, showMessage, currentMessage, newAlert]);

  useEffect(() => {
    const errorAlerts = alerts.filter((alert) => alert.level === Level.Error);
    if (errorAlerts.length > 0 && showMessage && !currentMessage) {
      console.log("Updating new alerts");
      const newMessage = errorAlerts[0].message;

      if (newMessage !== lastAlert) {
        setMessage((prevMessage) => [...prevMessage, newMessage]);
        setLastAlert(newMessage);
      }
    }
  }, [alerts, showMessage, currentMessage, lastAlert]);

  function getColor(level) {
    switch (level) {
      case Level.Info:
        return "#DEDEDE";
      case Level.Warning:
        return "#FF7A00";
      case Level.Error:
        return "#E43232";
      case Level.Success:
        return "#0EBF55";
      default:
        console.log(`Incorrect value for alert level ${level}`);
        return "#DEDEDE";
    }
  }

  function getStyle(level) {
    return {
      color: getColor(level),
    };
  }

  return (
    <div className="message-box">
      {showMessage && <Modal alertMessage={message} setOpenAlert={setCloseButtonIsClicked} />}
      {alerts.length === 0 ? (
        <div className="alert-message">Pas de messages.</div>
      ) : (
        alerts.map((alert, index) => (
          <div
            className="alert-message"
            key={index}
            style={getStyle(alert.level) || { color: "#DEDEDE" }}
          >
            {alert.message}
          </div>
        ))
      )}
      {/* <div className="arrow-down">
        <img
          className="arrow-outline"
          alt="scroll down"
          src={arrowLeftOutlineImage}
        />
      </div> */}
    </div>
  );
}

AlertMessageDisplay.propTypes = {
  alerts: PropTypes.array.isRequired,
};
